import axios from "axios";
import tvgConf from "@tvg/conf";

/**
 * Gets the list of routes with available tutorials
 * @returns {Promise<TutorialListFromService>}
 */
const getTutorialList = () => {
  const conf = tvgConf();
  const url = `${conf.config().service.capi}/tutorial`;

  const requestOptions = {
    method: "GET",
    url,
    headers: {
      "content-type": "application/json",
      "x-tvg-context": conf.context(),
      "x-requested-with": "XMLHttpRequest"
    },
    params: {
      isMinimized: true,
      isActive: true
    },
    withCredentials: true
  };

  return axios(requestOptions)
    .then(({ data }) => data)
    .catch((err) => err);
};

export default getTutorialList;
